import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, Observable, of, tap } from 'rxjs';
import { IAcRegistration } from '../shared/models/ac-registration.model';
import { environment } from '../../environments/environment';
import { IResponse } from '../shared/models/IResponse.model';
import { ToastService } from './toast.service';
import { Searchable } from '../shared/utils/searchable.type';


@Injectable({
  providedIn: 'root'
})
export class AcRegistrationsService {

  constructor(private httpClient: HttpClient, private toastService: ToastService) {
    this.fetchAcRegistrations().subscribe(() => {});
  }

  private _acRegistrations: BehaviorSubject<IAcRegistration[]> = new BehaviorSubject([]);
  getAcRegistrations(): BehaviorSubject<IAcRegistration[]> {
    return this._acRegistrations;
  }

  fetchAcRegistrations(filters: Searchable<IAcRegistration> = { isActive: true }): Observable<IAcRegistration[]> {
    return this.httpClient.post(`${environment.api_base_url}ac-registrations/search`, filters, {}).pipe(
      map((item: IResponse<IAcRegistration[]>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || [];
      }),
      catchError((error) => {
        this.toastService.showError("Error Loading Ac Registrations");
        return of([]);
      }),
      tap((value: IAcRegistration[]) => {
        this._acRegistrations.next(value);
      })
    );
  }

  saveAcRegistration(acRegistration: IAcRegistration): Observable<IAcRegistration> {
    let obs;
    if (acRegistration.id) {
      obs = this.httpClient.patch(`${environment.api_base_url}ac-registrations/${acRegistration.id}`, acRegistration, {})
    } else {
      obs = this.httpClient.post(`${environment.api_base_url}ac-registrations/create`, acRegistration, {})
    }
    return obs.pipe(
      map((item: IResponse<IAcRegistration>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || {};
      }),
      catchError((error) => {
        this.toastService.showError("Error saving AC Registration");
        return of({});
      })
    );
  }

  deleteAcRegistration(AcRegistrationId: number): Observable<any> {
    return this.httpClient.delete(`${environment.api_base_url}ac-registrations/${AcRegistrationId}`, {}).pipe(
      map((item: IResponse<boolean>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || {};
      }),
      catchError((error) => {
        this.toastService.showError("Error deleting ac registration");
        return of({});
      })
    );
  }
}
